/**
 * build url
 * @param {string} baseUrl base url
 * @param {Object} params query params map
 * @returns {string} full url
 */
export const buildUrl = (baseUrl, params) => {
  const query = Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join(`&`);

  return `${baseUrl}?${query}`;
};
